import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError, empty } from 'rxjs';

import { User } from '@models/user.model';
import { environment } from '@env/environment';
import { Client } from '@app/features/master/create-user/master-create-user-model';
const BASE_PATH = environment.basePath;
const headers = new HttpHeaders({ "Content-Type": "application/json" });
/**
 * Service class to communicate with the REST services
 */
@Injectable({
    providedIn: "root"
})
export class UserService {

    constructor(private httpClient: HttpClient) { }
    /**
* Retorna uma lista de usuários do cliente
* @return {  Observable<User[]>} 
*/


    getUsersByClientIdUsingGET(): Observable<User[]> {
        return this.httpClient.get<User[]>(`${BASE_PATH}/bff/clients/view/{uuid}/users`);
    }

    /**
    * Configuracao da tela criar usuario
    * @return {Observable<User>} 
    */
    createUserConfigGET(): Observable<User> {
        return this.httpClient.get<User>(`${BASE_PATH}/bff/master/users/create/config`);
    }
    /**
    * Retorna uma lista de clientes (MOCK)
    * @param {Client} filter filter clients
    * @return {  Observable<Client[]>} 
    */
    listUsingPOST(filter?: Client[]): Observable<Client[]> {
        return this.httpClient.post<Client[]>(`${BASE_PATH}/bff/createUserConfig/clients`, filter, { headers: headers });
    }

    listAllClients(filter?: Client[]): Observable<Client[]> {
        return null
    }

    getUserById(payload: string): Observable<User> {
        return this.httpClient.post<User>(`${BASE_PATH}/bff/screen/edit-user/user/findById`, payload, { headers: headers });
    }

    inactivateUser(id: number, user: User, reason: string): Observable<User> {
        return this.httpClient.put(`${BASE_PATH}/bff/screen/edit-user/user`,
            {
                id: id,
                status: "Inativo",
                reason: reason,
                name: user.name,
                nationality: user.nationality,
                login: user.login
            },
            { headers: headers });
    }

    /**
    * Retorna uma lista de ddis (MOCK)
    * @return {  Observable<any[]>} 
    */
    listDDIs(): Observable<any[]> {
        return this.httpClient.get<any[]>(`${BASE_PATH}/bff/master/users/create/ddis/list`);
    }


    listStatus(): Observable<any[]> {
        return this.httpClient.get<any[]>(`${BASE_PATH}/bff/screen/edit-user/user/status`);
    }

    /**
    * Inserir um usuário
    * @param {User} user user
    * @return {Observable<User>} 
    */
    postUsingPOST(user?: User): Observable<User> {
        // verify required parameters are not null or undefined
        if (user === null || user === undefined) {
            return throwError('Required parameter user was null or undefined.');
        }

        return this.httpClient.post<User>(`${BASE_PATH}/bff/users/create`, user, { headers: headers });
    }

    updateMyProfileRegister(user: User): Observable<HttpResponse<User>> {
        return this.httpClient.put<User>(`${BASE_PATH}/bff/screen/edit-user/user`, user, { headers: headers, observe: 'response' });
    }
}
